import { ParsedUrlQuery, stringify } from "querystring";

import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";

export const initializeSearchParams = (query: ParsedUrlQuery) => {
  const searchParams = new URLSearchParams(stringify(query));
  const validSearchParams = Object.keys(LangstonParameterSchema);
  const allSearchParams = [...searchParams.entries()];

  // Only load valid search parameters
  allSearchParams.forEach(([paramName]) => {
    if (!validSearchParams.includes(paramName)) {
      searchParams.delete(paramName);
    }
  });

  // Set default filters
  const isSortByParamValueValid = LangstonParameterSchema.sort.values
    .map(({ value }) => value)
    .includes(searchParams.get(LangstonParameterSchema.sort.key) || "");
  if (!isSortByParamValueValid) {
    searchParams.set(
      LangstonParameterSchema.sort.key,
      LangstonParameterSchema.sort.default,
    );
  }

  const isLanguagesParamValueValid = LangstonParameterSchema.languages.values
    .map(({ value }) => value)
    .includes(searchParams.get(LangstonParameterSchema.languages.key) || "");
  if (!isLanguagesParamValueValid) {
    searchParams.set(
      LangstonParameterSchema.languages.key,
      LangstonParameterSchema.languages.default,
    );
  }

  const hasPageParam = searchParams.get(LangstonParameterSchema.page.key);
  if (!hasPageParam) {
    searchParams.set(
      LangstonParameterSchema.page.key,
      LangstonParameterSchema.page.default.toString(),
    );
  }

  return searchParams;
};
